module.exports = __webpack_public_path__ + "img/b4-4.aa6b304.png";